import React from 'react';

const Shipping = item => {
    if (item.hasFreeShipping) {
        return (
            <li className="item-card-details-shipping">
                <span>{item.shippingPrice}</span>
            </li>
        );
    } else if (item.hasNonSpecifiedShipping) {
        return (
            <li className="item-card-details-shipping">
                <span>Ospec. frakt</span>
            </li>
        );
    } else if (item.isPickupOnly) {
        return (
            <li className="item-card-details-shipping">
                <span>Avhämtning</span>
            </li>
        );
    }
    return (
        <li className="item-card-details-shipping">
            <span>+{item.shippingPrice} frakt</span>
        </li>
    );
};

export default Shipping;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/item-card/shipping.jsx